import { useNavigate } from "react-router-dom";
import { ChevronLeft } from "lucide-react";

// Shared shell for the public Privacy / Terms pages. Uses the existing RoadRnr
// dark styling (light-mode overrides apply automatically via index.css) and gives
// a clear way back to the app. Publicly accessible — no auth required.
export const LegalLayout = ({ title, updated, children, testid }) => {
  const navigate = useNavigate();
  return (
    <div data-testid={testid} className="min-h-[100dvh] bg-[#050505] pb-20 text-white">
      <div className="rr-on-image sticky top-0 z-30 border-b border-white/10 bg-[#050505]/90 px-5 pb-4 pt-6 backdrop-blur-xl">
        <button
          data-testid="legal-back"
          onClick={() => navigate(-1)}
          className="mb-3 inline-flex items-center gap-1 text-sm font-semibold text-white/60 transition-colors hover:text-white"
        >
          <ChevronLeft className="h-4 w-4" /> Back
        </button>
        <h1 className="font-display text-3xl font-extrabold tracking-tight">{title}</h1>
        <p className="mt-1 text-sm text-white/45">Last updated: {updated}</p>
      </div>
      <div className="mx-auto max-w-md space-y-6 px-5 pt-6 text-sm leading-relaxed text-white/70">
        {children}
        <div className="pt-2">
          <button
            data-testid="legal-home"
            onClick={() => navigate("/")}
            className="inline-flex items-center gap-2 rounded-full bg-[#ff2a00] px-5 py-2.5 text-sm font-bold text-white transition-transform duration-200 active:scale-95"
          >
            Back to RoadRnr
          </button>
        </div>
      </div>
    </div>
  );
};

export const LegalSection = ({ heading, children }) => (
  <section className="space-y-2">
    <h2 className="font-display text-base font-bold text-white">{heading}</h2>
    {children}
  </section>
);
